module.exports = __webpack_public_path__ + "img/globe.bde9158f.svg";